// @ts-check
import dayjs from 'dayjs'

export const getAge = (birth) => {
  return dayjs().diff(birth, 'years', false)
}
